import Component from '../abstracts/Component';

export default class ParallaxComponent extends Component {


  constructor() {
    super();
  }


  // fix library
  aosRefresh(module) {

    let scrolled = false;

    if(!scrolled) {
      document.getElementsByTagName('body')[0].onscroll = function() {
        module.refresh();
      };
      scrolled = true;
    }
  }


  render() {
    this.moduleLoader.loadAos((module) => {
      this.aos = module.init( {} );
      this.aosRefresh(module);
      console.log('Aos initialised');

    }, (err) => console.error('error while importing aos', err))
  }
}




